import { render, staticRenderFns } from "./SubscriptionsEditor.vue?vue&type=template&id=5c7a81c9&"
import script from "./SubscriptionsEditor.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionsEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports